import { createFileRoute } from '@tanstack/react-router';
import { requireCollaborationFeature } from '@/features/notifications/guard';
import { NotificationsPage } from '@/features/notifications/notifications-page';

/** COL-05: notifications and e-mail preferences of the current user. */
export const Route = createFileRoute('/_app/notifications')({
  beforeLoad: ({ context }) => requireCollaborationFeature(context.queryClient),
  component: NotificationsPage,
});
